// I testi della landing di poptown.it (tela «PopTown Pop Style», artboard «Landing page»): le
// scene della sala riunioni, la squadra, i passi, le funzioni, gli approfondimenti e le domande.
// Il testo serve anche ai motori di ricerca (richiesta dell'utente del 2026-11-01: «metti un po'
// di testo in mezzo al sito così fa anche contesto in ricerca»).
import { popUrl } from '../../lib/pops';

export type Tint = 'blue' | 'lilac' | 'pink' | 'coral' | 'mint' | 'sun';
type Line = [avatar: string, who: string, tint: Tint, text: string];
export type Scene = {
  id: string;
  label: string;
  icon: string;
  title: string;
  done: string;
  lines: Line[];
};

export const pop = (avatar: string) => popUrl(`${avatar}-01`);

export const SCENES: Scene[] = [
  {
    id: 'vuln',
    label: 'Sicurezza',
    icon: 'security',
    title: 'vulnerabilità della notte',
    done: 'Attività pianificata: ogni giorno alle 7:30',
    lines: [
      [
        'project-manager',
        'Pia · PM',
        'lilac',
        'Idea: ogni mattina leggiamo le vulnerabilità nuove e prepariamo già le correzioni?',
      ],
      [
        'researcher',
        'Rino · Ricercatore',
        'blue',
        'Le advisory di GitHub le leggo io: le ultime 20, ordinate per data.',
      ],
      [
        'security',
        'Sara · Sicurezza',
        'coral',
        'Io tengo solo quelle che toccano davvero le nostre dipendenze.',
      ],
      [
        'developer',
        'Dario · Sviluppo',
        'mint',
        'Scrivo la patch, lancio solo i test che servono e apro la PR.',
      ],
      [
        'ux-ui',
        'Ugo · Design',
        'pink',
        'E il risultato arriva come una cartolina: tre righe e un pulsante «Approva».',
      ],
      [
        'project-manager',
        'Pia · PM',
        'lilac',
        'Perfetto. La pianifico per le 7:30: domattina trovi tutto pronto.',
      ],
    ],
  },
  {
    id: 'mail',
    label: 'Posta',
    icon: 'mail-clerk',
    title: 'la casella del lunedì',
    done: 'Quando arriva una mail dai clienti: risposte pronte in bozza',
    lines: [
      [
        'project-manager',
        'Pia · PM',
        'lilac',
        'Il lunedì la casella esplode. Possiamo smistarla noi?',
      ],
      [
        'mail-clerk',
        'Marta · Posta',
        'coral',
        'Leggo le mail nuove dei clienti e le divido: richieste, problemi, fatture.',
      ],
      [
        'triage',
        'Tito · Triage',
        'sun',
        'I problemi diventano ticket nel second brain, con la priorità giusta.',
      ],
      [
        'writer',
        'Wanda · Redattrice',
        'pink',
        'Per le richieste preparo le risposte in bozza, nel tuo tono.',
      ],
      [
        'notifier',
        'Nico · Notifiche',
        'blue',
        'Se qualcosa è urgente ti mando una push sul telefono.',
      ],
      [
        'project-manager',
        'Pia · PM',
        'lilac',
        'Fatto: parte da sola appena arriva una mail che corrisponde.',
      ],
    ],
  },
  {
    id: 'casa',
    label: 'Casa',
    icon: 'home',
    title: 'pioggia e giardino',
    done: 'Condizione attiva: pioggia sopra il 70%',
    lines: [
      [
        'project-manager',
        'Pia · PM',
        'lilac',
        'Se domani piove, l’irrigazione delle 6 è inutile. Ci pensiamo noi?',
      ],
      [
        'analyst',
        'Alba · Analista',
        'sun',
        'Interrogo l’API del meteo ogni ora: probabilità di pioggia per domani.',
      ],
      ['home', 'Elio · Casa', 'mint', 'Sopra il 70% sposto l’irrigazione a dopodomani.'],
      [
        'notifier',
        'Nico · Notifiche',
        'blue',
        'E ti avviso con una notifica, così lo sai anche tu.',
      ],
      [
        'analyst',
        'Alba · Analista',
        'sun',
        'Niente token sprecati: l’attività parte solo quando la condizione è vera.',
      ],
      [
        'project-manager',
        'Pia · PM',
        'lilac',
        'Ottimo. La creo come condizione su un’API esterna.',
      ],
    ],
  },
  {
    id: 'report',
    label: 'Report',
    icon: 'data-scientist',
    title: 'il report del venerdì',
    done: 'Attività pianificata: ogni venerdì alle 17',
    lines: [
      [
        'project-manager',
        'Pia · PM',
        'lilac',
        'Il venerdì voglio sapere com’è andata la settimana del progetto.',
      ],
      [
        'data-scientist',
        'Dora · Dati',
        'blue',
        'Conto i ticket chiusi, aperti e bloccati nel second brain, con i tempi.',
      ],
      [
        'researcher',
        'Rino · Ricercatore',
        'blue',
        'Cerco in rete le novità delle librerie che usiamo.',
      ],
      [
        'writer',
        'Wanda · Redattrice',
        'pink',
        'Metto tutto in una pagina: tre numeri, tre rischi, tre prossimi passi.',
      ],
      ['mail-clerk', 'Marta · Posta', 'coral', 'E la mando per email a chi segue il progetto.'],
      [
        'project-manager',
        'Pia · PM',
        'lilac',
        'Pianificato. Se qualcosa si blocca, te lo dico prima.',
      ],
    ],
  },
];

export const CREW: { avatar: string; name: string; role: string; tint: Tint }[] = [
  { avatar: 'project-manager', name: 'Pia', role: 'Project manager', tint: 'lilac' },
  { avatar: 'researcher', name: 'Rino', role: 'Ricercatore', tint: 'blue' },
  { avatar: 'security', name: 'Sara', role: 'Sicurezza', tint: 'coral' },
  { avatar: 'developer', name: 'Dario', role: 'Sviluppatore', tint: 'mint' },
  { avatar: 'ux-ui', name: 'Ugo', role: 'Designer', tint: 'pink' },
  { avatar: 'analyst', name: 'Alba', role: 'Analista', tint: 'sun' },
];

export const STEPS: { tint: Tint; title: string; text: string }[] = [
  {
    tint: 'lilac',
    title: 'Racconti l’idea',
    text: 'Scrivi al PM come scriveresti a un collega. Ti fa le domande giuste, poi propone un piano.',
  },
  {
    tint: 'mint',
    title: 'Il team si organizza',
    text: 'Il PM chiama i pop adatti, ognuno con il suo modello e i suoi strumenti, e li segui dal vivo.',
  },
  {
    tint: 'sun',
    title: 'Tu approvi',
    text: 'Il risultato arriva in chat, per email o come notifica. Decidi tu cosa parte davvero.',
  },
];

export const ICON = {
  proj: 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
  plan: 'M8 2v4 M16 2v4 M3 9h18 M5 5h14v16H5z M12 13v3l2 1',
  api: 'M8 9l-4 3 4 3 M16 9l4 3-4 3 M13.5 6l-3 12',
  web: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M2 12h20 M12 2a15 15 0 0 1 0 20 M12 2a15 15 0 0 0 0 20',
  mail: 'M3 6h18v12H3z M3 7l9 6 9-6',
  bell: 'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9 M10.3 21a1.9 1.9 0 0 0 3.4 0',
  models: 'M12 2l9 5v10l-9 5-9-5V7z M12 12l9-5 M12 12v10 M12 12L3 7',
  home: 'M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z M9 12l2 2 4-4',
};

export const FEATURES: { tint: Tint; title: string; text: string; d: string }[] = [
  {
    tint: 'lilac',
    title: 'Progetti',
    text: 'Ogni progetto con il suo repository, il piano, i ticket nel second brain e il team che lo segue.',
    d: ICON.proj,
  },
  {
    tint: 'sun',
    title: 'Pianificazioni',
    text: 'Attività a orario o quando succede qualcosa: una mail, un ticket, un valore di un’API.',
    d: ICON.plan,
  },
  {
    tint: 'blue',
    title: 'API esterne',
    text: 'Qualunque servizio HTTP: GET e scritture, autenticazione a scelta, schema dei parametri.',
    d: ICON.api,
  },
  {
    tint: 'mint',
    title: 'Ricerca web',
    text: 'I pop cercano in rete e leggono le pagine pubbliche, mai la rete di casa.',
    d: ICON.web,
  },
  {
    tint: 'coral',
    title: 'Gmail e calendario',
    text: 'Leggere, rispondere, riordinare la posta e gestire gli appuntamenti, con più account.',
    d: ICON.mail,
  },
  {
    tint: 'pink',
    title: 'Notifiche',
    text: 'Push sul telefono, anche ad alta priorità, ed email con il risultato.',
    d: ICON.bell,
  },
  {
    tint: 'blue',
    title: 'Tutti i modelli',
    text: 'Claude, Codex, Gemini e i modelli locali, anche più account insieme.',
    d: ICON.models,
  },
  {
    tint: 'mint',
    title: 'A casa tua',
    text: 'Gira sul tuo server: login, passkey e nessun dato che esce senza che tu lo voglia.',
    d: ICON.home,
  },
];

export const DEEP: { tint: Tint; d: string; title: string; text: string; points: string[] }[] = [
  {
    tint: 'lilac',
    d: ICON.proj,
    title: 'Gestione dei progetti',
    text: 'Un progetto in PopTown riunisce codice, decisioni e lavoro da fare. Il PM legge il repository e la documentazione, propone un piano diviso in fasi e lo trasforma in ticket nel second brain; il team di triage li analizza e li prepara per chi li deve svolgere.',
    points: [
      'Repository Git collegato, con branch, commit e pull request',
      'Piano in fasi, approvato da te prima di partire',
      'Ticket, priorità e stato sempre allineati nel second brain',
    ],
  },
  {
    tint: 'sun',
    d: ICON.plan,
    title: 'Pianificazioni e condizioni',
    text: 'Le attività partono da sole: a un orario, ogni N minuti, oppure quando succede qualcosa. Una condizione guarda una fonte (il second brain, Gmail, il calendario o un’API) e avvia il team solo quando serve, senza consumare token a vuoto.',
    points: [
      'Orari, giorni della settimana e fuso orario',
      'Condizioni su email, ticket, appuntamenti e valori di un’API',
      'Consegna del risultato in chat, per email o come notifica',
    ],
  },
  {
    tint: 'blue',
    d: ICON.api,
    title: 'Integrazioni con API esterne',
    text: 'Colleghi qualunque servizio HTTP pubblico: meteo, gestionali, advisory di sicurezza, dati aperti. Scegli l’autenticazione, descrivi i parametri che il servizio accetta e i pop sanno cosa chiedere. Le scritture (POST, PUT, PATCH, DELETE) si accendono una per una.',
    points: [
      'Nessuna, Bearer, chiave in intestazione o nell’indirizzo, utente e password',
      'Schema dei parametri in JSON: i valori li sceglie il pop',
      'Il segreto resta cifrato sul server e non torna mai alla plancia',
    ],
  },
  {
    tint: 'mint',
    d: ICON.web,
    title: 'Ricerca web',
    text: 'Quando serve un’informazione aggiornata i pop cercano in rete e leggono le pagine pubbliche. Il contenuto che arriva da fuori viene filtrato e trattato come dato, non come istruzione, così una pagina non può comandare gli agenti.',
    points: [
      'Ricerca e lettura di pagine pubbliche',
      'Mai indirizzi privati o della rete di casa',
      'Filtro contro le istruzioni nascoste nei contenuti',
    ],
  },
];

export const FAQ: { q: string; a: string }[] = [
  {
    q: 'Che cos’è PopTown?',
    a: 'Una piattaforma per orchestrare agenti AI in squadra: un project manager virtuale divide il lavoro fra agenti specializzati, ognuno con il suo modello e i suoi strumenti.',
  },
  {
    q: 'Quali modelli di intelligenza artificiale usa?',
    a: 'Claude Code, Codex e Gemini con i tuoi abbonamenti, anche più account dello stesso tipo, e modelli locali sul tuo hardware.',
  },
  {
    q: 'Può lavorare da solo, senza che io lo chieda?',
    a: 'Sì: con le pianificazioni le attività partono a orario o quando una condizione è vera, per esempio una mail in arrivo o un valore di un’API.',
  },
  {
    q: 'Si collega ai miei servizi?',
    a: 'Gmail e calendario, il second brain per progetti e ticket, notifiche push e qualunque API esterna. Ogni strumento si concede ai pop uno per uno.',
  },
  {
    q: 'Dove stanno i miei dati?',
    a: 'Sul tuo server. PopTown è ospitato in proprio, con login, passkey e credenziali cifrate.',
  },
];
